import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Terms() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-gradient-to-r from-slate-900 via-indigo-950 to-slate-900 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-slate-400 hover:text-white mb-6 text-sm transition-colors">
            &larr; {t("common.back_home", "Înapoi la pagina principală")}
          </Link>
          <h1 className="text-3xl font-bold text-white">
            {t("terms.title", "Termeni și Condiții de Utilizare")}
          </h1>
          <p className="mt-2 text-slate-400 text-sm">
            {t("terms.last_updated", "Ultima actualizare")}: 22.03.2026
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose prose-slate max-w-none text-slate-700 space-y-8">

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">1. Definiții</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>„Platforma"</strong> — aplicația web și mobilă iGROWth, disponibilă la adresa app.sportiveducat.ro și prin aplicația Android „SportivEducat"</li>
              <li><strong>„Operatorul"</strong> — iGROWTH NEXUS SRL, proprietarul și administratorul Platformei</li>
              <li><strong>„Utilizatorul"</strong> — orice persoană care accesează și utilizează Platforma, indiferent de rol (administrator de club, antrenor, sportiv, părinte)</li>
              <li><strong>„Clubul"</strong> — entitatea sportivă înregistrată pe Platformă</li>
              <li><strong>„Contul"</strong> — contul individual al Utilizatorului, creat prin înregistrare sau invitație</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">2. Obiectul serviciului</h2>
            <p>
              Platforma iGROWth oferă un sistem digital de management al cluburilor sportive, care include:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Gestionarea cluburilor, echipelor, antrenorilor și sportivilor</li>
              <li>Planificarea și urmărirea sesiunilor de antrenament</li>
              <li>Monitorizarea prezenței la antrenamente</li>
              <li>Sistem de gamificare cu puncte, clasamente și recompense</li>
              <li>Conținut educațional (quiz-uri, video-uri)</li>
              <li>Sistem de facturare și plăți</li>
              <li>Comunicare prin notificări push și email</li>
              <li>Calendar și management al evenimentelor</li>
              <li>Metrici de performanță sportivă</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">3. Crearea contului și înregistrarea</h2>
            <p>
              3.1 Pentru a utiliza Platforma, Utilizatorul trebuie să își creeze un cont furnizând informații corecte și complete.
            </p>
            <p>
              3.2 Conturile pot fi create prin:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Înregistrare directă</strong> — pentru administratorii de club, prin formularul de înregistrare</li>
              <li><strong>Invitație</strong> — pentru antrenori și sportivi, prin link-ul de invitație trimis de administratorul clubului sau antrenor</li>
            </ul>
            <p>
              3.3 Utilizatorul este responsabil pentru păstrarea confidențialității credențialelor de acces (email și parolă).
            </p>
            <p>
              3.4 Pentru sportivii minori (sub 18 ani), înregistrarea se face cu acordul părintelui sau tutorelui legal, ale cărui date de contact vor fi stocate în profilul sportivului.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">4. Roluri și responsabilități</h2>

            <h3 className="text-lg font-medium text-slate-800 mt-4 mb-2">4.1 Administrator de Platformă</h3>
            <p>Are acces complet la toate funcționalitățile platformei, inclusiv gestionarea cluburilor, utilizatorilor și configurărilor globale.</p>

            <h3 className="text-lg font-medium text-slate-800 mt-4 mb-2">4.2 Administrator de Club</h3>
            <p>Gestionează clubul propriu: echipe, antrenori, sportivi, sesiuni, facturare, evenimente și setări ale clubului.</p>

            <h3 className="text-lg font-medium text-slate-800 mt-4 mb-2">4.3 Antrenor</h3>
            <p>Gestionează echipele atribuite: planifică sesiuni, înregistrează prezența, monitorizează performanța sportivilor și trimite invitații.</p>

            <h3 className="text-lg font-medium text-slate-800 mt-4 mb-2">4.4 Sportiv</h3>
            <p>Vizualizează programul de antrenamente, participă la quiz-uri educaționale, acumulează puncte și monitorizează propria performanță.</p>

            <h3 className="text-lg font-medium text-slate-800 mt-4 mb-2">4.5 Părinte</h3>
            <p>Monitorizează activitatea, prezența, evenimentele și plățile copilului/copiilor înscriși pe Platformă.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">5. Obligațiile Utilizatorului</h2>
            <p>Utilizatorul se obligă:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Să furnizeze informații corecte și actualizate la înregistrare</li>
              <li>Să nu partajeze credențialele de acces cu terțe persoane</li>
              <li>Să nu utilizeze Platforma în scopuri ilegale sau neautorizate</li>
              <li>Să nu încerce să acceseze date ale altor utilizatori fără autorizare</li>
              <li>Să nu interfereze cu funcționarea normală a Platformei</li>
              <li>Să respecte drepturile celorlalți utilizatori ai Platformei</li>
              <li>Să notifice imediat Operatorul în cazul utilizării neautorizate a contului</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">6. Sistemul de gamificare</h2>
            <p>
              6.1 Platforma include un sistem de puncte și recompense cu scop educativ și motivațional.
              Punctele sunt acordate pentru participarea la antrenamente, completarea quiz-urilor și alte activități.
            </p>
            <p>
              6.2 Punctele și recompensele nu au valoare monetară și nu pot fi transferate, vândute sau convertite în bani.
            </p>
            <p>
              6.3 Operatorul își rezervă dreptul de a modifica sistemul de puncte și clasamentele fără notificare prealabilă.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">7. Plăți și facturare</h2>
            <p>
              7.1 Plățile pentru abonamentele cluburilor sunt procesate prin <strong>Stripe</strong>, un furnizor de plăți autorizat.
              Operatorul nu stochează datele cardurilor bancare.
            </p>
            <p>
              7.2 Facturile sunt generate automat și sunt disponibile în secțiunea de facturare a contului.
            </p>
            <p>
              7.3 Politica de rambursare: rambursările sunt gestionate individual, la cererea Utilizatorului, în conformitate cu legislația românească privind protecția consumatorului.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">8. Proprietatea intelectuală</h2>
            <p>
              8.1 Toate drepturile de proprietate intelectuală asupra Platformei (cod sursă, design, mărci, conținut) aparțin Operatorului.
            </p>
            <p>
              8.2 Utilizatorul primește o licență limitată, neexclusivă și netransferabilă de a utiliza Platforma conform acestor Termeni.
            </p>
            <p>
              8.3 Conținutul generat de utilizatori (informații de profil, date sportive) rămâne proprietatea acestora,
              însă Operatorul primește o licență de utilizare necesară furnizării serviciului.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">9. Disponibilitatea serviciului</h2>
            <p>
              9.1 Operatorul depune eforturi rezonabile pentru a asigura disponibilitatea Platformei 24/7,
              dar nu garantează funcționarea neîntreruptă.
            </p>
            <p>
              9.2 Operatorul își rezervă dreptul de a suspenda temporar accesul pentru mentenanță,
              actualizări sau în caz de forță majoră, cu notificarea prealabilă a utilizatorilor când este posibil.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">10. Limitarea răspunderii</h2>
            <p>
              10.1 Platforma este furnizată „ca atare" (as is). Operatorul nu garantează că Platforma va îndeplini
              toate cerințele Utilizatorului sau că va funcționa fără erori.
            </p>
            <p>
              10.2 Operatorul nu este responsabil pentru:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Pierderile cauzate de utilizarea incorectă a Platformei</li>
              <li>Întreruperile cauzate de factori externi (internet, dispozitiv, furnizori terți)</li>
              <li>Conținutul introdus de utilizatori</li>
              <li>Deciziile luate pe baza datelor afișate pe Platformă</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">11. Suspendarea și închiderea contului</h2>
            <p>
              11.1 Utilizatorul poate solicita oricând închiderea contului contactând Operatorul la{" "}
              <a href="mailto:contact@sportiveducat.ro" className="text-indigo-600 hover:text-indigo-800">contact@sportiveducat.ro</a>.
            </p>
            <p>
              11.2 Operatorul poate suspenda sau închide contul Utilizatorului în cazul încălcării prezentelor Termeni,
              cu notificarea prealabilă a Utilizatorului.
            </p>
            <p>
              11.3 La închiderea contului, datele personale vor fi șterse conform Politicii de Confidențialitate,
              cu excepția celor pentru care există obligații legale de păstrare.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">12. Notificări</h2>
            <p>
              12.1 Platforma utilizează notificări push (prin Firebase Cloud Messaging) și email pentru comunicări importante.
            </p>
            <p>
              12.2 Utilizatorul poate dezactiva notificările push din setările aplicației, dar comunicările esențiale
              (modificări de cont, securitate) vor fi trimise prin email.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">13. Modificarea Termenilor</h2>
            <p>
              Operatorul își rezervă dreptul de a modifica prezentele Termeni și Condiții. Utilizatorii vor fi
              notificați cu privire la modificările semnificative prin notificări în aplicație sau email. Continuarea
              utilizării Platformei după notificarea modificărilor constituie acceptarea noilor Termeni.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">14. Legea aplicabilă și jurisdicția</h2>
            <p>
              Prezentele Termeni și Condiții sunt guvernate de legislația din România. Orice litigiu va fi soluționat
              pe cale amiabilă, iar în cazul în care aceasta nu este posibilă, de instanțele competente din București, România.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">15. Contact</h2>
            <p>
              Pentru orice întrebări sau solicitări referitoare la acești Termeni, ne puteți contacta la:
            </p>
            <p className="mt-2">
              <strong>iGROWTH NEXUS SRL</strong><br />
              Email: <a href="mailto:contact@sportiveducat.ro" className="text-indigo-600 hover:text-indigo-800">contact@sportiveducat.ro</a><br />
              Website: <a href="https://sportiveducat.ro" className="text-indigo-600 hover:text-indigo-800" target="_blank" rel="noopener noreferrer">sportiveducat.ro</a>
            </p>
          </section>

          <section className="bg-slate-50 border border-slate-200 rounded-xl p-6 mt-8">
            <h2 className="text-xl font-semibold text-slate-900 mb-3">Finanțare europeană</h2>
            <p>
              Această platformă web și aplicație mobilă au fost realizate cu sprijinul financiar al Uniunii Europene prin
              Programul Educației și Ocupare 2021-2027, cofinanțat din FSE+. Conținutul acestui material nu reprezintă în
              mod obligatoriu poziția oficială a Uniunii Europene sau a Guvernului României.
            </p>
          </section>

        </div>
      </div>

      {/* Footer */}
      <div className="bg-slate-50 border-t py-6 text-center text-sm text-slate-500">
        <span className="text-emerald-600">i</span>GROWth &copy; {new Date().getFullYear()} — <Link to="/privacy" className="text-indigo-600 hover:text-indigo-800">Politica de Confidențialitate</Link>
      </div>
    </div>
  );
}
